module.exports = __webpack_public_path__ + "img/gd_03.b3072c99.png";